export enum EPhoneVerificationStep {
  PHONE,
  VERIFY,
}

export const PHONE_STEP_TITLE = {
  [EPhoneVerificationStep.PHONE]: 'Укажите ваш номер мобильного телефона',
  [EPhoneVerificationStep.VERIFY]: 'Подтвердите номер телефона',
};
